import {useMutation} from "@tanstack/react-query";
import {UpdateGtaRateRequest} from "@/Stub/V1";
import {processValidationErrors} from "@/Util/Api/processValidationErrors";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";

export const useUpdateGtaRate = () => useMutation({
    mutationFn: async (data: UpdateGtaRateRequest) => {
        try {
            return await GtaRatesApiClient.updateGtaRate(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});
